<template>
    <div id="tags" :style="{width: width, height: height}"></div>
</template>

<script>
import echarts from 'echarts'
import ROUNTER_RELATION from '@/config/router-relation.js'
import RELATIONSHIPS from '@/config/articles/relationships.js'

export default {
    props: {
        width:{
            type:String,
            default:'800px'
        },
        height: {
            type:String,
            default:"800px"
        },
    },
    data() {
        return {
            myChart:null,
            tagTotal:[],
            notesTotal:0,
            relation:ROUNTER_RELATION,
            relationships:RELATIONSHIPS
        }
    },
    mounted() {
        let _this = this;
        _this.getData();
        _this.initData();
    },
    methods: {
        getData(){
            let _this = this;
            let category = _this.$store.state.categoryTotal;
            let articles = _this.$store.state.articlesTotal;
            for(let key in category) {
                if(key === "学习笔记"){
                    _this.notesTotal = category[key];
                }else if(key){
                    _this.tagTotal.push({
                        name:key,
                        value: category[key]
                    })
                }
            }
            for(let article in articles) {
                if(article){
                    _this.tagTotal.push({
                        name:article,
                        value: articles[article]
                    })   
                } 
            }
        },
        itemClick(params){
            let _this = this;
            let router = _this.$router;
            let relation = _this.relation;
            let name = params.name;
            let value = params.data?params.data.value:0;
            if(value > 0){
                let link = relation[name.toLowerCase()]
                router.push({path:'/blog/category', query:{type:link}})
            }
        },
        initData() {
            let _this = this;
            let allTags = _this.tagTotal;
            let tagData = [];
            // 颜色
            allTags.map(item =>{
                let color = "rgb(" + (~~(Math.random() * 255)) + "," + (~~(Math.random() * 255)) + "," + (~~(Math.random() * 255)) + ")";
                tagData.push({
                    "name": item.name,
                    "value": item.value,
                    x: 0,
                    y: 0,
                    "symbolSize": 60,
                    "draggable": true,
                    "itemStyle": {
                        "normal": {
                            "borderColor": color,
                            "borderWidth": 4,
                            "shadowBlur": 60,
                            "shadowColor": color,
                            "color": color,
                        }
                    },
               }) 
            })   
            let option = {
                tooltip: {},
                animationDurationUpdate: function(idx) {
                    // 越往后的数据延迟越大
                    return idx * 100;
                },
                animationEasingUpdate: 'bounceIn',
                color: ['#fff', '#fff', '#fff'],
                series: [{
                    type: 'graph',
                    layout: 'force',
                    force: {
                        repulsion: 300,
                        edgeLength: 100
                    },
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}',
                            fontSize: 16,
                            fontStyle: '600',
                        }
                    },
                    data: [
                        {
                            "name": "学习笔记",
                            "value": _this.notesTotal,
                            x: 500,
                            y: 56,
                            "symbolSize": 66,
                            "draggable": true,
                            "itemStyle": {
                                "normal": {
                                    "borderColor": "#FF8C00",
                                    "borderWidth": 4,
                                    "shadowBlur": 66,
                                    "shadowColor": "#FF8C00",
                                    "color": "#FF8C00"
                                }
                            }
                        },
                        ...tagData 
                    ],
                    links:this.relationships
                }]
            }
            _this.myChart = echarts.init(document.getElementById('tags'));
            _this.myChart.setOption(option);
            _this.myChart.on('click', 'series', function (params) {
                if(params.dataType == "node"){
                    _this.itemClick(params)
                }
            });
        },

    },
}
</script>>



